import { generateUniqueId } from '../../helpers/common';

export const SET_APP_BAR_LEFT_ELEMENT = generateUniqueId();
export const SET_APP_BAR_RIGHT_ELEMENT = generateUniqueId()
export const SET_APP_BAR_TITLE = generateUniqueId();
export const SET_APP_BAR_CENTER_ELEMENT = generateUniqueId();
export const SET_APP_BAR_VISIBLITY = generateUniqueId();